import React, {useEffect, useState} from "react"
import {Report} from "../../components/report/Report"
import {connect} from "react-redux"
import {OperationMessagesRootState} from "../../store/infoList/types"
import {ThunkDispatch} from "redux-thunk"
import {AnyAction, compose} from "redux"
import {setCurReport} from "../../store/infoList/actions"
import {setNavigation} from "../../utils/bridge"


const DailyPage: React.FC<any> = (props) => {
  const [reportContent, setContent] = useState('')
  useEffect(() => {
    (async () => {
      await props.getCurReport()
      await setNavigation({
        title: '我的探探',
        leftHandler() {
          window.history.back()
        },
        rightText: ' '
      })
      setContent(props.curReportContent)
    })()
  }, [])
  return <div style={{
    padding: 16,
    backgroundColor: 'rgb(255, 255, 255)',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
  }}>
    <Report reportContent={reportContent}/>
  </div>
}


const mapStateToProps = (state: OperationMessagesRootState) => {
  return {
    curReportContent: state.operationMessages.curReportContent
  }
}
const mapDispatchToProps = (
  dispatch: ThunkDispatch<OperationMessagesRootState, void, AnyAction>
) => {
  return {
    getCurReport: compose(dispatch, setCurReport)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DailyPage)
